class x {
  get maxFriendship() {
    return window.vue.$store.state.$db.NamedFriendshipExpArray.length;
  }
  cri_key = '51408295487268137';
  cri_class = ['Fighter', 'Magician', 'Priest', 'Knight', 'Alchemist'];

  roomIDtoStr = {
    0: 'Desk',
    1: 'Chair',
    2: 'Storage',
    3: 'Bedding',
    4: 'Appliances',
    5: 'Goods',
    6: 'Hobby',
    7: 'WallDecoration',
    8: 'Carpet',
    9: 'Screen',
    10: 'Floor',
    11: 'Wall',
    12: 'Background',
  };
  CRI_PROXY = "https://aerial-prairie-motorcycle.glitch.me/cri/?name=";
}

const tmp = new x();

export default tmp;
